import { observer } from 'mobx-react-lite';
import { PropsWithChildren, useEffect } from 'react';
import { DEVELOPER_DOMAIN } from 'src/constants/Developer';
import { useAuthStore } from 'src/stores/AuthStore/AuthStore';
import { useOrganizationStore } from 'src/stores/OrganizationStore/OrganizationStore';
import TagManager, { TagManagerArgs } from '@sooro-io/react-gtm-module';
import { getDomainNameByEmail } from 'src/constants/utils';
import { CONFIG } from 'src/constants/config';

export const GTMProvider = observer(({ children }: PropsWithChildren) => {
  const { userDetails } = useAuthStore();
  const { organizationDetails } = useOrganizationStore();

  useEffect(() => {
    const isProduction = process.env.NODE_ENV === 'production';
    const gtmId = CONFIG.GTM_ID;

    if (!organizationDetails || !gtmId || !isProduction || !userDetails) {
      return;
    }

    const isNotHanabiDomain =
      getDomainNameByEmail(userDetails.email) !== DEVELOPER_DOMAIN;

    const nonce = document.getElementById('hanabi-inline-csp-nonce')?.nonce;

    if (!nonce) {
      throw new Error('nonce value is not set by the server.');
    }

    if (userDetails && organizationDetails && isNotHanabiDomain) {
      const tagManagerArgs: TagManagerArgs = {
        gtmId: gtmId,
        dataLayer: {
          customer: userDetails._id,
          org_id: userDetails.organizationId,
        },
        nonce,
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, [userDetails, organizationDetails]);

  return <>{children}</>;
});
